module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-song-list"
  }, [_c('ul', _vm._l((_vm.songs), function(item, index) {
    return _c('li', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rank),
        expression: "rank"
      }],
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.getRankCls(index)
    }, [_vm._v(_vm._s(_vm.getRankTxt(index)))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.getDesc(item)))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4dbd2ccc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/MySongList/MySongList.vue
// module id = 480
// module chunks = 9